/** A ledger line's distinct categories (TMMAPP-0108, § Overrides 2). */
import type { VirtualAccountRegisterPart } from '@/api/registers';
import type { AllocationContra } from '@/api/transactions';

/** One distinct category of a line (null = uncategorized), its signed total and any contra tag. */
export interface LineCategory {
  categoryId: number | null;
  amountMinor: number;
  contra: AllocationContra | null;
}

/** The line's distinct categories in part order, each with the parts' signed sum. */
export function lineCategories(parts: readonly VirtualAccountRegisterPart[]): LineCategory[] {
  const out: LineCategory[] = [];
  for (const part of parts) {
    const found = out.find((row) => row.categoryId === part.categoryId);
    if (found) {
      found.amountMinor += part.amountMinor ?? 0;
      found.contra = found.contra ?? part.contra;
    } else {
      out.push({
        categoryId: part.categoryId,
        amountMinor: part.amountMinor ?? 0,
        contra: part.contra,
      });
    }
  }
  return out;
}
